import React, { useState } from "react";
import { X, UserPlus, Loader2 } from "lucide-react";
import { showToast } from "../../components/common/notification/Notification";
import { addTeamMember } from "./networkApi";

const AddTeamMemberModal = ({ show, team, onClose, onSuccess }) => {
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    mobile_number: "",
    email_address: "",
    role: "MEMBER",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  if (!show || !team) return null;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.first_name?.trim()) {
      showToast("First Name is required", { type: "error" });
      return;
    }

    if (!formData.mobile_number?.trim() || formData.mobile_number.length < 10) {
      showToast("A valid 10-digit mobile number is required", { type: "error" });
      return;
    }

    try {
      setIsSubmitting(true);
      const res = await addTeamMember({
        team_id: team.id,
        first_name: formData.first_name.trim(),
        last_name: formData.last_name.trim(),
        mobile_number: formData.mobile_number.trim(),
        email_address: formData.email_address.trim(),
        role: formData.role,
      });

      if (res?.statusType === "SUCCESS" || res?.status === "SUCCESS" || res?.partnerTeamMember) {
        showToast("Team member added successfully!", { type: "success" });
        onSuccess?.();
        onClose?.();
      } else {
        showToast(res?.text || res?.message || "Failed to add member", { type: "error" });
      }
    } catch (err) {
      console.error("Add team member error:", err);
      showToast(err?.response?.data?.text || "An error occurred while adding team member", {
        type: "error",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="net-modal-overlay" onClick={onClose}>
      <div className="net-modal" onClick={(e) => e.stopPropagation()}>
        <form onSubmit={handleSubmit} className="net-modal-form">
          <div className="net-modal__header">
            <div style={{ display: "flex", alignItems: "center", gap: "0.6rem" }}>
              <div
                style={{
                  width: "36px",
                  height: "36px",
                  borderRadius: "10px",
                  background: "#faf5ff",
                  color: "#9333ea",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                <UserPlus size={18} />
              </div>
              <div>
                <h3 className="net-modal__title">Add Member to {team.name}</h3>
                <p style={{ margin: 0, fontSize: "0.75rem", color: "#64748b" }}>
                  Assign team member to this group
                </p>
              </div>
            </div>
            <button type="button" className="net-drawer__close" onClick={onClose}>
              <X size={18} />
            </button>
          </div>

          <div className="net-modal__body">
            <div className="net-form-grid-2">
              <div className="net-form-group">
                <label className="net-form-label">First Name *</label>
                <input
                  type="text"
                  name="first_name"
                  className="net-form-input"
                  placeholder="e.g. Vikram"
                  value={formData.first_name}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="net-form-group">
                <label className="net-form-label">Last Name</label>
                <input
                  type="text"
                  name="last_name"
                  className="net-form-input"
                  placeholder="e.g. Mehta"
                  value={formData.last_name}
                  onChange={handleInputChange}
                />
              </div>
            </div>

            <div className="net-form-grid-2">
              <div className="net-form-group">
                <label className="net-form-label">Mobile Number *</label>
                <input
                  type="tel"
                  name="mobile_number"
                  className="net-form-input"
                  placeholder="10-digit number"
                  value={formData.mobile_number}
                  onChange={handleInputChange}
                  maxLength={10}
                  required
                />
              </div>
              <div className="net-form-group">
                <label className="net-form-label">Email Address</label>
                <input
                  type="email"
                  name="email_address"
                  className="net-form-input"
                  placeholder="member@agency.com"
                  value={formData.email_address}
                  onChange={handleInputChange}
                />
              </div>
            </div>

            <div className="net-form-group">
              <label className="net-form-label">Role in Team</label>
              <select
                name="role"
                className="net-form-select"
                value={formData.role}
                onChange={handleInputChange}
              >
                <option value="MEMBER">Team Member / Agent</option>
                <option value="LEAD">Team Lead / Supervisor</option>
                <option value="COORDINATOR">Coordinator</option>
              </select>
            </div>
          </div>

          <div className="net-modal__footer">
            <button type="button" className="net-btn net-btn--secondary" onClick={onClose}>
              Cancel
            </button>
            <button
              type="submit"
              className="net-btn net-btn--primary"
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <>
                  <Loader2 size={16} className="net-spin" /> Adding...
                </>
              ) : (
                "Add to Team"
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddTeamMemberModal;
